/**
 * @generated SignedSource<<b7de5a29dc40910a62a24ea2bbbf9688>>
 * @relayHash f5527593a5c52d2161583db1c954d07c
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f5527593a5c52d2161583db1c954d07c

import type { ConcreteRequest } from 'relay-runtime';
export type UpdateIssueIssueTypeInput = {
  clientMutationId?: string | null | undefined;
  issueId: string;
  issueTypeId?: string | null | undefined;
};
export type updateIssueIssueTypeSharedMutation$variables = {
  input: UpdateIssueIssueTypeInput;
};
export type updateIssueIssueTypeSharedMutation$data = {
  readonly updateIssueIssueType: {
    readonly issue: {
      readonly issueType: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type updateIssueIssueTypeSharedMutation$rawResponse = {
  readonly updateIssueIssueType: {
    readonly issue: {
      readonly id: string;
      readonly issueType: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type updateIssueIssueTypeSharedMutation = {
  rawResponse: updateIssueIssueTypeSharedMutation$rawResponse;
  response: updateIssueIssueTypeSharedMutation$data;
  variables: updateIssueIssueTypeSharedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueType",
  "kind": "LinkedField",
  "name": "issueType",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateIssueIssueTypeSharedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateIssueIssueTypePayload",
        "kind": "LinkedField",
        "name": "updateIssueIssueType",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateIssueIssueTypeSharedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateIssueIssueTypePayload",
        "kind": "LinkedField",
        "name": "updateIssueIssueType",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "f5527593a5c52d2161583db1c954d07c",
    "metadata": {},
    "name": "updateIssueIssueTypeSharedMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "170109027cc0d8811a4bfee4f5b45bf1";

export default node;
